export const partnerIdMap = {
  '239': 'Axis',
  '219': 'Bajaj',
  '197': 'SCB',
  '289': 'L&T',
  '403': 'pl',
  '404': 'HDFC_PL',
  '405': 'ICICI_PL',
  '406': 'Axis_PL',
  '407': 'Bajaj_PL',
  '408': 'IndusInd_PL',
  '409': 'Tata_Capital_PL',
  '410': 'L&T_PL',
  '411': 'Hero_Fincorp',
  '412': 'Kotak_PL',
  '413': 'Piramal_PL',
  '420': 'KreditBee_PL',
  '644': 'plDev',
  '656': 'hlDev',
  '418': 'ambak_HL',
  '430': 'Zet_loan_assistant_PL',
}
